// extracted by mini-css-extract-plugin
module.exports = {"employmentInfo":"assets-employment_employmentInfo_1QdrX","unemployedInfo":"assets-employment_unemployedInfo_1ibBd"};